
import React, { useState, useRef, useEffect } from "react";
import { getData,postData } from '../../../../../ApiServices/ApiService';
import { ORG_CONFIGURATION_ACTIVITY_REGISTER,ORG_GET_CONFIGURATION_CONTACTS_LIST,
  ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER,ORG_GET_EMPLOYEE_LIST} from '../../../../../ApiServices/BaseURL';
import { logFrontendException } from '../../../../../Utils/Exception';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';




const WhatsAppLogsListController = ({whatsAppLogLoading,whatsAppLogError,whatsAppLogList,setwhatsAppLogLoading,setwhatsAppLogError,setwhatsAppLogList,onRefresh}) => {
    const [sentBy, setSentBy] = useState({});

    const [whatsAppLogFilter,setWhatsappLogFilter] = useState([])
    const [whatsAppLogFilterLoading, setwhatsAppLogFilterLoading] = useState(false);
    const [whatsAppLogFilterError, setwhatsAppLogFilterError] = useState('');
    const [selectList, setSelectList] = useState({});
    const [date, setDate] = useState('');
    const [clientList, setClientList] = useState([]);
    const [error, setError] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [selectedClientError, setSelectedClientError] = useState('');
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedClients, setSelectedClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterError, setFilterError] = useState('');
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    const pageName = "WhatsAppLogsController";

    const [showFilters, setShowFilters] = useState(false);
    
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(whatsAppLogFilter?.length / itemsPerPage);
    
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentWhatsappLogList = whatsAppLogFilter?.slice(indexOfFirstItem, indexOfLastItem);

    const [expandedRows, setExpandedRows] = useState({});
    const toggleExpand = (key) => {
      setExpandedRows((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    };
  
    const handlePageChange = (pageNumber) => {
      if (pageNumber > 0 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
      }
    };

    useEffect(() => {
      if(whatsAppLogList){
        setWhatsappLogFilter(whatsAppLogList)
      }
      setwhatsAppLogFilterLoading(whatsAppLogLoading);
      setwhatsAppLogFilterError(whatsAppLogError)
    }, [whatsAppLogList,whatsAppLogError,whatsAppLogLoading]);

    const handleSearchClient = async () => {
        try {
          setError('');
          setSelectedClientError('');
          setLoading(true);
          setClientList([]);
          // setSelectedClients([])
          if (!searchUser) {
            setError('Please enter valid text'); return;
          }
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
          const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }
    
          //console.log('team Data', payLoad);
          // Make the API call
          const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
          const responseData = await response.json();
          //console.log('response Data', responseData);
    
          // Check for success (200) and internal status code
          if (response?.status === 200) {
            if (responseData?.statusCode === 200) {
              if (responseData?.message.toLowerCase() === 'success') {
                setClientList(responseData?.dataJ || []);
                // setSuccess(responseData?.info);
                setTimeout(() => {
                  // handleClose();
                  // onValueChange();
                }, 3000);
              } else {
                setError(responseData?.info || 'Failed to fetch Client. Please try again.');
              }
            } else {
              setError(responseData?.info || 'Failed to fetch Client.');
            }
          }
          // Token-related errors: 400, 401, 403
          else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
            if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
              setError('Unauthorized access. Your session may have expired. Please log in again.');
              // Optionally, redirect to the login page or refresh the token
              // Example: redirectToLogin();
            } else {
              setError(responseData?.info || 'Bad request. Please check the request parameters.');
            }
            setIsLoginPopup(true)
          }
          // Internal Server Error: 500
          else if (response?.status === 500) {
            setError(responseData?.info || 'Internal Server Error. Please try again later.');
          }
          // Unexpected or network-related errors
          else {
            setError('Unexpected error occurred. Please try again later.');
          }
        } catch (error) {
          // Handle various error scenarios
          if (error.response) {
            // Server responded with a status outside the 2xx range
            setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
          } else if (error.request) {
            // Request was made but no response was received
            setError('No response received from the server. Please check your network connection and try again.');
          } else {
            // An error occurred in setting up the request
            setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
          }
        } finally {
          setLoading(false);
        }
      };


    const handleSearchInputText = (value) => {
        setSearchUser(value);
        // setClientNameError('');
        setClientList([]);
        if (!value) {
          setSearchUser('');
        }
      };
    
    const handleSelectClient = (client) => {
      setSelectedClient(client);
      setSelectedClients(client)
      setSearchUser(client?.client_name);
      setClientList([]);
      setSelectedClientError('');
    };

    const [filters, setFilters] = useState({
      sent_to: '',
      sent_by: null,
      sent_date: null,
      client_id: '',
    });
  
    const handleFilterChange = (name, value) => {
      //console.log('name : ', name, 'value : ', value)
      setFilterError('');
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value,
      }));
    };
    
    const fetchwhatsappLogFilter = async () => {
        
        try {
          setFilterError('');
          if (!selectList?.value && !sentBy?.value && !date && !selectedClient?.client_id ) {
            setFilterError('Please enter/select any one of the above');
            return;
          }
          setWhatsappLogFilter([])
          setwhatsAppLogFilterLoading(true);
          setwhatsAppLogFilterError('');
          setExpandedRows({});
          
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
          const payload = {
            "emp_id_auth": storedUserInfo?.emp_id,
            "action_type": "filter",
            "channel_name":"whatsapp",
            "sent_to":selectList?.value,
            "sent_by":sentBy?.value,
            "sent_date":date,
            "client_id":selectedClient?.client_id || ''
           
          }
          console.log("payLaod--",payload)
          const response = await postData(ORG_CONFIGURATION_ACTIVITY_REGISTER, payload);
          const responseData = await response.json();
    
    
          if (response.status === 200 && responseData.status_code === 200) {
            if (responseData.message.toLowerCase() === "success") {
              if (responseData?.dataJ?.length > 0) {
                setWhatsappLogFilter(responseData?.dataJ || []);
                // setCurrentPage(1);
              } else {
                setwhatsAppLogFilterError(responseData?.info || "No whastapp activity list is available.");
                // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData || '');
    
              }
            } else {
                setwhatsAppLogFilterError(responseData?.info || "Failed to fetch whatsapp list.");
              // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData || '');
            }
          }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
            setwhatsAppLogFilterError('Unauthorized access. Your session may have expired. Please log in again.');
            setIsLoginPopup(true)
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData || response || '');
                   
            } else {
                setwhatsAppLogFilterError(responseData?.info || "Failed to fetch whatsapp activity list.Please try again.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "whatsAppLogList", responseData || response || '');
          }
        } catch (err) {
            setwhatsAppLogFilterError("Failed to fetch whatsapp activity list.Please check your internet connection and try again.");
          logFrontendException(storedUserId, pageName, "whatsAppLogList-catch", err || '');
        } finally {
            setwhatsAppLogFilterLoading(false);
        }
      };

     const resetFilters = () => {
        if (selectList?.value || sentBy?.value || date || selectedClient?.client_id) {
            setwhatsAppLogList([]);
            setCurrentPage(1);
            setFilterError('');
            onRefresh();
        }
        setFilterError('');
        setSelectList({});
        setSentBy({});
        setDate('');
        setSelectedClient(null);
        setClientList([]);
        setSearchUser('');
        setwhatsAppLogFilterError('');
        setError('');
        setExpandedRows({});
    };

    const cancelFilters = () => {
        resetFilters();
        setShowFilters(!showFilters);
    }
    
    return {
        onRefresh,
        whatsAppLogFilter:currentWhatsappLogList,
        whatsAppLogFilterLoading,
        whatsAppLogFilterError,
        setWhatsappLogFilter,
        setwhatsAppLogFilterLoading,
        setwhatsAppLogFilterError,
        fetchwhatsappLogFilter,
        sentBy,
        setSentBy,
        // handleInputChange,
        currentPage,
        handlePageChange,
        totalPages,
        currentWhatsappLogList,
        selectList,
        setSelectList,
        setDate,
        date,
        clientList, 
        setClientList,
        error, setError,
        searchUser, setSearchUser,
        selectedClientError, setSelectedClientError,
        selectedClients, setSelectedClients,
        loading, setLoading,
        handleSearchInputText,
        handleSearchClient,
        handleSelectClient,
        selectedClient, setSelectedClient,
        filterError,
        showFilters,
        setShowFilters,
        resetFilters,
        cancelFilters,
        expandedRows,
        toggleExpand,
        setExpandedRows,
    }

}

export default WhatsAppLogsListController